import { LandingLayout } from 'layouts';
import { useLocation } from 'react-router';
import { ContentLeft, Footer, Header, type HeaderItem, PasswordLogin } from 'features/onboarding';
import { useExpiredPassword, useOnSuccessLogin, useOnboardingNavigation } from '../hooks';
import type { OnboardingLocationState } from '../types';

export type LoginLocationState = OnboardingLocationState;

const PagePasswordLogin = () => {
  const location = useLocation();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const state: LoginLocationState | undefined = location.state;
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { onNavigateToCheckCode, onNavigateToForgotPassword, onNavigateToPrimaryLogin, onNavigateToSignUp } =
    useOnboardingNavigation<LoginLocationState>();
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { onSuccessLogin } = useOnSuccessLogin<LoginLocationState>();
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { onExpiredPassword } = useExpiredPassword<LoginLocationState>();

  const headerButtons: HeaderItem[] = [
    {
      label: 'Sign up',
      async onClick() {
        await onNavigateToSignUp();
      },
      type: 'primary',
    },
  ];

  return (
    <LandingLayout
      contentLeft={<ContentLeft />}
      contentRight={
        <PasswordLogin<LoginLocationState>
          onExpiredPassword={onExpiredPassword}
          onNavigateToCheckCode={onNavigateToCheckCode}
          onNavigateToForgotPassword={onNavigateToForgotPassword}
          onNavigateToPrimaryLogin={onNavigateToPrimaryLogin}
          onSuccessLogin={onSuccessLogin}
          publicCommunityId={state?.join_community_id}
          state={state}
        />
      }
      footer={<Footer />}
      header={<Header items={headerButtons} />}
    />
  );
};

export default PagePasswordLogin;
